export default "__VITE_ASSET__D_EkEyR3__"